import { DisputeState, DisputeType } from '#app/typings/orderClientLitige';
import { PaymentMethod } from '#app/typings/orderPayment';

export enum OrderDocumentType {
  DELIVERY_NOTE_ORDER_CLIENT = 'delivery_note_order_client',
  INVOICE_ORDER_CLIENT = 'invoice_order_client',
  CREDIT_ORDER_CLIENT = 'credit_order_client',
  INVOICE_ORDER_PURVEYOR = 'invoice_order_purveyor',
}

export const OrderDocumentTypeTranslation: Record<OrderDocumentType, string> = {
  [OrderDocumentType.DELIVERY_NOTE_ORDER_CLIENT]: 'Bon de livraison client',
  [OrderDocumentType.INVOICE_ORDER_CLIENT]: 'Facture client',
  [OrderDocumentType.CREDIT_ORDER_CLIENT]: 'Avoir client',
  [OrderDocumentType.INVOICE_ORDER_PURVEYOR]: 'Facture fournisseur',
};

export type TaxTypeId = '2' | '3' | '5' | '10' | '12' | '19';

export const TaxTypeTranslation: Record<TaxTypeId, string> = {
  2: '5.5%',
  3: '20%',
  5: '6%',
  10: '8%',
  12: '21%',
  19: '17%',
};

export type OrderDocument = {
  id: number;
  orderType: OrderDocumentType;
  reference: string;
  pricePaidTTC: number;
  orderDocumentByProducts: {
    id: number;
    orderClientByProduct: {
      byProduct: number;
    };
    productLabel: string;
    quantity: number;
  }[];
  orderClientLitiges: {
    state: DisputeState;
    type: DisputeType;
    orderClientLitigeByProducts: {
      amount: number;
      byProduct: number;
      available: number;
    }[];
  }[];
};

export type OrderDocumentStats = {
  orderClientUuid: string;
  date: string;
  type: OrderDocumentType;
  reference: string;
  totalProductsHT: number;
  totalHT: number;
  totalTTC: number;
  totalTVA: number;
  totalShippingFees: number;
  totalPaymentFees: number;
  taxRates: Partial<
    Record<
      TaxTypeId,
      {
        base: number;
        rate: number;
        total: number;
      }
    >
  >;
  paymentMethod: PaymentMethod;
};
